import React from 'react';
import { Input } from '../ui/input';
import { splitTotal } from '../employee-form/SalarySplit';

const KEYS = [['basic', 'Basic'], ['housing', 'Housing'], ['transportation', 'Transport'], ['other', 'Other']];
export const sumSal = (s) => KEYS.reduce((t, [k]) => t + (parseFloat(s?.[k]) || 0), 0);

export const BulkRow = ({ emp, row, mode, onChange, onRemove }) => {
  const sal = row.salary || {};
  const set = (k, v) => onChange({ ...row, total: '', salary: { ...sal, [k]: v } });
  const cur = sumSal(emp.salary);
  const total = sumSal(sal);
  const diff = mode === 'raise' ? total - cur : cur - total;
  const pct = mode === 'raise' ? (cur ? (diff / cur) * 100 : 0) : (total ? (diff / total) * 100 : 0);
  return (
    <tr className="align-top" data-testid={`bulk-row-${emp.employee_code}`}>
      <td className="px-2 py-2">
        <p className="font-medium text-sm">{emp.name}</p>
        <p className="text-[11px] text-gray-500">{emp.employee_code} · {emp.position}</p>
        <p className="text-[11px] text-gray-500">Now: {cur.toLocaleString()}</p>
      </td>
      {mode === 'raise' && (
        <td className="px-2 py-2">
          <Input className="h-8 text-xs w-36" placeholder={emp.position} value={row.new_position || ''}
            onChange={e => onChange({ ...row, new_position: e.target.value })} data-testid={`bulk-position-${emp.employee_code}`} />
        </td>
      )}
      <td className="px-2 py-2">
        <Input type="number" className="h-8 text-xs w-24" placeholder="Total" value={row.total || ''}
          onChange={e => { const s = splitTotal(e.target.value); onChange({ ...row, total: e.target.value, salary: s || sal }); }}
          data-testid={`bulk-total-${emp.employee_code}`} />
        <p className="text-[10px] text-gray-400 mt-0.5">60/25/10/5 split</p>
      </td>
      {KEYS.map(([k, l]) => (
        <td key={k} className="px-1 py-2">
          <Input type="number" className="h-8 text-xs w-20" placeholder={l} value={sal[k] ?? ''}
            onChange={e => set(k, e.target.value)} data-testid={`bulk-${k}-${emp.employee_code}`} />
        </td>
      ))}
      <td className="px-2 py-2 text-xs whitespace-nowrap">
        {total > 0 ? (
          <span className={diff > 0 ? 'text-red-600 font-semibold' : diff < 0 ? 'text-green-600 font-semibold' : 'text-gray-400'} data-testid={`bulk-diff-${emp.employee_code}`}>
            {diff > 0 ? '+' : ''}{diff.toLocaleString()} ({pct.toFixed(1)}%)
          </span>
        ) : '—'}
      </td>
      <td className="px-1 py-2">
        <button type="button" onClick={onRemove} className="text-gray-400 hover:text-rose-600 text-xs" data-testid={`bulk-remove-${emp.employee_code}`}>✕</button>
      </td>
    </tr>
  );
};
